(function () {
  let scheduled = false;

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;

    // Run after the drawer/sections render finishes (two ticks is usually enough)
    window.setTimeout(() => {
      scheduled = false;
      requestAnimationFrame(() => requestAnimationFrame(applyVendorMinimumGuard));
    }, 60);
  }

  function getMeta() {
    return document.getElementById("cast-vendor-minimum");
  }

  function getCurrencyIso(meta) {
    return meta?.dataset?.currencyIso || "CAD";
  }

  function formatMoneyFromCents(cents, currencyIso) {
    const iso = currencyIso || "CAD";
    try {
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: iso });
    } catch (e) {
      return (cents / 100).toFixed(2) + " " + iso;
    }
  }

  function findCheckoutTargets() {
    // Both cart page + mini cart in your theme use name="checkout"
    const buttons = Array.from(document.querySelectorAll('button[name="checkout"]'));
    const links = Array.from(document.querySelectorAll('a[href^="/checkout"]'));
    return { buttons, links };
  }

  function setWarning(el, html, show) {
    if (!el) return;
    if (show) {
      el.style.display = "block";
      el.innerHTML = html;
    } else {
      el.style.display = "none";
      el.innerHTML = "";
    }
  }

  function applyVendorMinimumGuard() {
    const meta = getMeta();
    if (!meta) return;

    const minimum = parseInt(meta.dataset.vendorMinimumCents || "0", 10);
    const subtotal = parseInt(meta.dataset.vendorSubtotalCents || "0", 10);
    const vendors = (meta.dataset.targetVendors || "")
      .split(",")
      .map(v => v.trim())
      .filter(Boolean);

    const currencyIso = getCurrencyIso(meta);
    const remaining = Math.max(0, minimum - subtotal);
    const hasVendorItems = meta.dataset.hasVendorItems === "true";
    const shouldBlock = hasVendorItems && subtotal < minimum;

    const msg =
      `<strong>Vendor minimum not met.</strong><br>` +
      `Items from <strong>${vendors.join(" or ")}</strong> must total at least <strong>${formatMoneyFromCents(minimum, currencyIso)}</strong> to proceed to checkout.<br>` +
      `Current: <strong>${formatMoneyFromCents(subtotal, currencyIso)}</strong>. Add <strong>${formatMoneyFromCents(remaining, currencyIso)}</strong> more of these vendor items.`;

    // Mini cart placeholder (persisted in Liquid)
    const warnMini = document.getElementById("cast-vendor-warning-mini");

    // Cart page warning (you already have working; keep it simple)
    const warnCart =
      document.getElementById("cast-vendor-warning-cart") ||
      document.querySelector("#main-cart-footer .cart-footer")?.querySelector("#cast-vendor-warning-cart");

    // If you don’t have a cart placeholder, create once (cart page is stable, safe to inject)
    let cartEl = warnCart;
    if (!cartEl) {
      const cartFooter =
        document.querySelector("#main-cart-footer .cart-footer") ||
        document.querySelector("#main-cart-footer") ||
        document.querySelector(".cart-footer") ||
        document.querySelector("form#cart");

      if (cartFooter) {
        cartEl = document.createElement("div");
        cartEl.id = "cast-vendor-warning-cart";
        cartEl.setAttribute("role", "status");
        cartEl.style.margin = "12px 0";
        cartEl.style.padding = "12px 14px";
        cartEl.style.border = "1px solid #d1a000";
        cartEl.style.borderRadius = "8px";
        cartEl.style.background = "#fff8e1";
        cartEl.style.color = "#3b2f00";
        cartEl.style.fontSize = "14px";
        cartFooter.prepend(cartEl);
      }
    }

    setWarning(warnMini, msg, shouldBlock);
    setWarning(cartEl, msg, shouldBlock);

    // Disable checkout affordances
    const { buttons, links } = findCheckoutTargets();

    buttons.forEach(btn => {
      if (shouldBlock) {
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        btn.style.opacity = "0.6";
        btn.style.cursor = "not-allowed";
      } else {
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
        btn.style.opacity = "";
        btn.style.cursor = "";
      }
    });

    links.forEach(a => {
      if (shouldBlock) {
        a.setAttribute("aria-disabled", "true");
        a.dataset.vendorMinBlocked = "true";
        a.style.pointerEvents = "none";
        a.style.opacity = "0.6";
        a.style.cursor = "not-allowed";
      } else {
        a.removeAttribute("aria-disabled");
        if (a.dataset.vendorMinBlocked === "true") {
          a.style.pointerEvents = "";
          a.style.opacity = "";
          a.style.cursor = "";
          delete a.dataset.vendorMinBlocked;
        }
      }
    });

    // Backup: prevent checkout submit via any /cart form
    document.querySelectorAll('form[action^="/cart"]').forEach(form => {
      if (form.dataset.vendorMinHandlerAttached === "true") return;
      form.dataset.vendorMinHandlerAttached = "true";

      form.addEventListener("submit", (e) => {
        if (!shouldBlock) return;

        const submitter = e.submitter;
        const isCheckoutIntent =
          (submitter && submitter.name === "checkout") ||
          (submitter && /checkout/i.test(submitter.textContent || ""));

        if (isCheckoutIntent) {
          e.preventDefault();
          e.stopPropagation();
          // scroll whichever warning exists/visible
          (warnMini || cartEl)?.scrollIntoView?.({ behavior: "smooth", block: "center" });
        }
      }, { passive: false });
    });
  }

  document.addEventListener("DOMContentLoaded", scheduleApply);

  // When mini cart opens, your theme likely triggers it via click.
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (!t) return;
    const cartTrigger =
      t.closest?.('.header-mini-cart, [data-cart-drawer], [data-drawer-trigger], a[href*="/cart"]') ||
      (typeof t.className === "string" && t.className.toLowerCase().includes("cart"));

    if (cartTrigger) scheduleApply();
  });

  // Cart changes (qty/remove/coupon) often happen via AJAX; this re-checks
  document.addEventListener("change", (e) => {
    const t = e.target;
    if (t?.closest?.('form[action^="/cart"]')) scheduleApply();
  });

  document.addEventListener("cart:updated", scheduleApply);
})();
document.addEventListener("click", (e) => {
  const t = e.target;
  if (!t) return;

  // After any click inside the mini cart, re-check shortly after AJAX update
  const inMiniCart = t.closest?.("#HeaderMiniCart, #header-mini-cart, .header-mini-cart, .mini-cart-footer");
  if (inMiniCart) {
    setTimeout(scheduleApply, 200);
    setTimeout(scheduleApply, 600);
  }
});